import { State } from 'src/types'
import { webDrawUtil } from 'src/features/brands/util/canvas'
import { indexWrapBack } from '../lace/connectIndexToWeb'
import { flatWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/flatWeb'
import { crossWeb, crossWebCenterStitch, crossWebWithEdge } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/crossWeb'
import { onePeaceWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/onPeaceWeb'
import { laceOfNetWeb, netWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/netWeb'
import { netWeb2 } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/netWeb2'
import { laceOfNetWebDouble, netWebDouble } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/netWebDouble'
import { crossDoubleWeb, crossDoubleWebWithEdge } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/crossDoubleWeb'
import { basketForPitcherWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/basketWeb'
import { twoPeaceWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/twoPeaceWeb'
import { hJointWeb, hWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/hWeb'
import { underWeb as laceOfUnderWeb, underWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/lace/underWeb'
import { fenceWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/fenceWeb'
import { jointCheckerWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/jointCheckerWeb'
import { lacingNetWeb } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/lacingNetWeb'
import { hWebWithEdge } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/hWebWithEdge'
import { laceOfNetWebDoubleWithJoint } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/newWebDoubleWithJoint'
import { type2Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/type2Web'
import { type7Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/type7Web'
import { type1_2Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/type1_2Web'
import { type2_2Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/type2_2Web'
import { type6Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/type6Web'
import { type3Web } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/web/type3Web'
import { type22Web } from './type22Web'
import { type23Web } from './type23Web'
import { type24Web } from './type24Web'
import { type25Web } from './type25Web'
import { type26Web } from './type26Web'
import { type27Web } from './type27Web'
import { type28Web } from './type28Web'
import { underWebForNetWeb1, underWebForNetWeb2 } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/lace/underWeb'
// 以下を RAG de Lion 配下で実装しimport -> 描画
// import { indexWrapBack } from 'src/features/brands/atoms/canvas/glove/front/lace/connectIndexToWeb'

export const webOfGloveFrontDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, web2Color, laceColor, stitchColor, edgeColor } = webDrawUtil(state)
  if (webMatcher(['type1'])) flatWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type1_2'])) type1_2Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type2'])) type2Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type2_2'])) type2_2Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type3'])) type3Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type4'])) basketForPitcherWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type5'])) twoPeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type6'])) type6Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type7'])) type7Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type8', 'type9'])) crossWebCenterStitch(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type10'])) crossWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type10_2'])) crossWebWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type11'])) onePeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type12'])) hWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type12_2'])) hWebWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type13'])) hJointWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type14'])) lacingNetWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type15'])) jointCheckerWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['type16_2'])) netWeb(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type16'])) netWeb2(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type17'])) netWebDouble(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type18'])) netWebDouble(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type19'])) fenceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type20', 'type21'])) crossDoubleWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type21_2'])) crossDoubleWebWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['type22'])) type22Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type23'])) type23Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type24'])) type24Web(ctx, edgeColor, laceColor, stitchColor, webColor)
  if (webMatcher(['type25'])) type25Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type26'])) type26Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type27'])) type27Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type28'])) type28Web(ctx, webColor, edgeColor, laceColor, stitchColor)
}

export const rightLaceOfNetWebDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, laceColor, stitchColor } = webDrawUtil(state)
  if (webMatcher(['type16', 'type16_2'])) laceOfNetWeb(ctx, laceColor)
  if (webMatcher(['type17'])) laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type18'])) laceOfNetWebDoubleWithJoint(ctx, webColor, laceColor, stitchColor)
  indexWrapBack(ctx, laceColor, -10, -100) // 上
  if (!webMatcher(['type16', 'type16_2', 'type17', 'type18', 'type24'])) indexWrapBack(ctx, laceColor, 0, 0) // 下
}

export const laceOfUnderWebDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, laceColor, stitchColor } = webDrawUtil(state)
  if (webMatcher(['type5'])) laceOfUnderWeb(ctx, laceColor, -10, 30)
  if (webMatcher(['type24'])) laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['type16', 'type16_2', 'type17', 'type18', 'type24'])) {
    underWebForNetWeb1(ctx, laceColor, 0, 0)
    underWebForNetWeb1(ctx, laceColor, -17, 30)
    underWebForNetWeb2(ctx, laceColor, -133, 95, -20)
    underWebForNetWeb2(ctx, laceColor, -15, 28, 0)
  } else {
    underWeb(ctx, laceColor, 10, 0) // ウェブ下＿右
    underWeb(ctx, laceColor, -32, 64) // ウェブ下＿左
  }
}
